// ~/config/theme.config.ts

import FinanceCard from "~/components/common/financeCard.vue"

export const lightTheme = {
  /* nav bar and section */
  navBg: "#EAF7FF",
  primaryBg: "#ffffff",
  secondaryBg: "#ffffff",

  iconBg: "#F7FCFF",
  /* General colors */
  background: "#ffffff",
  text: "#424D71",
  primary: "#EAF7FF",
  secondary: "#0027AF",
  surface: "#F5F5F5",
  accent: "#FF4081",
  success: "#4CAF50",
  warning: "#FFC107",
  error: "#F44336",
  info: "#2196F3",
  darkBlue: "#0B112D",
  yellow: "#FED202",

  /* Buttons */
  buttonBg: "#0027AF",
  buttonText: "#ffffff",
  buttonHoverBg: "#1558b0",
  buttonDisabledBg: "#cccccc",
  buttonDisabledText: "#888888",

  /* Links */
  linkColor: "#1A73E8",
  linkHoverColor: "#1558b0",

  /* Cards & Surfaces */
  cardBg: "#ffffff",
  cardText: "#424D71",
  cardShadow: "0 2px 8px rgba(0,0,0,0.1)",
  cardBorder: "#e0e0e0",

  /* Inputs */
  inputBg: "#ffffff",
  inputText: "#424D71",
  inputBorder: "#cccccc",
  inputPlaceholder: "#888888",
  inputFocusBorder: "#1A73E8",

  /* Modals / Dialogs */
  modalBg: "#ffffff",
  modalText: "#424D71",
  modalOverlay: "rgba(0,0,0,0.4)",

  /* Misc */
  borderColor: "#e0e0e0",
  shadow: "0 2px 6px rgba(0,0,0,0.1)",

  /* Text colors */
  primaryText: "#1B2559",
  secondaryText: "#424D71",
  tertiaryText: "#0027AF",
  quaternaryText: "#005DAB",
  neutralText: "#595959",

  /* Badges */
  primaryBadge: "#EAF7FF",
  secondaryBadge: "#EFF9FF",
  tertiaryBadge: "#002FA7",
  quaternaryBadge: "#595959",
  neutralBadge: "#EAF7FF",
  successBadge: "#F9FDF4",

  testimonialsCardBg: "#F7FCFF",

  trustedByCardBg: "#EAF7FF"

}

export const darkTheme = {
  /* nav bar and section */
  navBg: "#171717",
  primaryBg: "#030303",
  secondaryBg: "#101010",

  iconBg: "#101010",
  /* General colors */
  background: "#1E1E1E",
  text: "#ffffff",
  primary: "#171717",
  secondary: "#90CAF9",
  surface: "#121212",
  accent: "#FF4081",
  success: "#4CAF50",
  warning: "#FFC107",
  error: "#F44336",
  info: "#29B6F6",
  darkBlue: "#0B112D",
  yellow: "#FED202",

  /* Buttons */
  buttonBg: "#0027AF",
  buttonText: "#ffffff",
  buttonHoverBg: "#1769aa",
  buttonDisabledBg: "#333333",
  buttonDisabledText: "#888888",

  /* Links */
  linkColor: "#2196F3",
  linkHoverColor: "#1769aa",

  /* Cards & Surfaces */
  cardBg: "#1A1A2E",
  cardText: "#ffffff",
  cardShadow: "0 2px 12px rgba(0,0,0,0.5)",
  cardBorder: "#333333",

  /* Inputs */
  inputBg: "#1A1A2E",
  inputText: "#ffffff",
  inputBorder: "#333333",
  inputPlaceholder: "#aaaaaa",
  inputFocusBorder: "#2196F3",

  /* Modals / Dialogs */
  modalBg: "#121212",
  modalText: "#ffffff",
  modalOverlay: "rgba(0,0,0,0.6)",

  /* Misc */
  borderColor: "#333333",
  shadow: "0 2px 12px rgba(0,0,0,0.5)",

  /* Text colors */
  primaryText: "#FFFFFF",
  secondaryText: "#424D71",
  tertiaryText: "#FFD100",
  quaternaryText: "#FFD100",
  neutralText: "#FFFFFF",

  /* Badges */
  primaryBadge: "#383838",
  secondaryBadge: "#525252",
  tertiaryBadge: "#171717",
  quaternaryBadge: "#474747",
  neutralBadge: "#323232",
  successBadge: "#F9FDF440",

  testimonialsCardBg: "#030303",

  trustedByCardBg: "#7F7D7C"
}